<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<app-ui-modal #modalMensagens [hideFooter]="true" [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h5 class="modal-title">Cadastro de Mensagens</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModal(modalMensagens, 'mensagem')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="app-modal-body">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-12">
            <label class="sub-title">Boas Vindas</label>
            <input type="text" class="form-control" [(ngModel)]="objMensagens.BoasVindas" name="objMensagens.BoasVinda"
              placeholder="">
          </div>
          <div class="col-md-12">
            <label class="sub-title">Sucesso</label>
            <input type="text" class="form-control" [(ngModel)]="objMensagens.Sucesso"
              name="ordemAtiobjMensagens.Sucessovidade" placeholder="">
          </div>
          <div class="col-md-12">
            <label class="sub-title">Falha</label>
            <input type="text" class="form-control" [(ngModel)]="objMensagens.Falha" name="objMensagens.Falha"
              placeholder="">
          </div>
          <div class="col-md-12">
            <label class="sub-title">Saída</label>
            <input type="text" class="form-control" [(ngModel)]="objMensagens.Saida" name="objMensagens.Saida"
              placeholder="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 text-left">
          <br>
          <button type="button" class="btn btn-danger" (click)="closeModal(modalMensagens, 'mensagem')">
            <i class="fa fa-chevron-circle-left"></i>
            Voltar
          </button>
        </div>
        <div class="col-md-6 text-right">
          <br>
          <button type="button" class="btn btn-primary" (click)="closeModal(modalMensagens, 'mensagem')">
            <i class="feather icon-check-circle"></i>
            Adicionar
          </button>
        </div>
      </div>
    </div>
  </div>
</app-ui-modal>

<app-ui-modal #modalCadastroModulo [hideFooter]="true" [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h5 class="modal-title">Cadastro de Módulos</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModal(modalCadastroModulo, 'modulo')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="app-modal-body">
    <app-modal-cadastro-modulos [ID_PROGRAMA]="programaSelecionado"  [item]="editarItemSelecionado"
      (acaoVoltar)="closeModal(modalCadastroModulo, 'modulo')">
    </app-modal-cadastro-modulos>
  </div>
</app-ui-modal>

<app-ui-modal #modalAddEtapa [hideFooter]="true" [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h5 class="modal-title">Adicionar nova Trilha</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModal(modalAddEtapa, 'etapa')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="app-modal-body">
    <app-modal-add-etapa (acaoVoltar)="closeModal(modalAddEtapa, 'etapa')"
      [ID_MODULO]="moduloSelecionado?.iD_MODULO_PROGRAMA" [item]="editarItemSelecionado"></app-modal-add-etapa>
  </div>
</app-ui-modal>

<app-ui-modal #modalAddFormulario [hideFooter]="true" [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h5 class="modal-title">Busca Formulário</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModal(modalAddFormulario,'formulario')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="app-modal-body">
    <app-modal-add-formulario (itemSelecionado)="receberFormularioSelecionada($event, modalAddFormulario)">
    </app-modal-add-formulario>
  </div>
</app-ui-modal>


<app-ui-modal #modalAddMidia [hideFooter]="true" [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h5 class="modal-title">Busca Mídias</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModal(modalAddMidia, 'midia')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="app-modal-body">
    <app-minha-tabela [endPoint]="urlMidia" [arrayCabecalho]="arrayCabecalho"
      (itemSelecionar)="receberMidiaSelecionada($event, modalAddMidia)">
    </app-minha-tabela>
  </div>
</app-ui-modal>



<div class="row">
  <div class="col-12 col-lg-7">
    <app-card cardTitle="Programas Ativos" blockClass="table-border-style" [options]="false">
      <ng-select [ngClass]="'tag-select'" [options]="arrayProgramas" [(ngModel)]="programaSelecionado"
        (ngModelChange)="buscarModulos()">
      </ng-select>
    </app-card>
  </div>
  <div class="col-12 col-lg-5 d-flex align-items-stretch">

  </div>
</div>
<div class="row mt-3">

  <div class="col-12 col-lg-4 col-xl-3 mb-3" *ngIf="programaSelecionado">
    <!--<div class="col-3">-->
    <app-card cardTitle="Modulos" blockClass="table-border-style" [options]="false">
      <div class="row">
        <button type="button" class="btn btn-primary" data-toggle="modal" (click)="openModal(modalCadastroModulo)">
          <i class="feather icon-plus-circle"></i>
          Cadastrar Novo Modúlo</button>

      </div>
      <br>
      <div class="row">
        <div class="col-12">
          <div class="list-group list-group-flush">
            <div class="list-group-item py-2" *ngFor="let item of arrayModulos"
              [ngClass]="{highlighted: selectedRowIndex == item.id}">
              <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
                <div class="flex-grow-1 mr-lg-3" style="cursor: pointer;" (click)="selectModulo(item)">
                  <div class="font-weight-semibold text-break">{{item.titulo }}</div>
                  <div class="small text-muted">Ordem: {{item.ordem }}</div>
                  <div class="small mt-1">
                    <span *ngIf="item.obrigatorio" class="badge badge-success">Obrigatório</span>
                    <span *ngIf="!item.obrigatorio" class="badge badge-warning">Não obrigatório</span>
                  </div>
                </div>
                <div class="d-flex flex-wrap align-items-center mt-2 mt-lg-0" style="gap: 0.4rem;">
                  <button type="button" class="btn btn-dark btn-sm" (click)="openModal(modalCadastroModulo, item)"
                    title="Editar módulo">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button type="button" class="btn btn-danger btn-sm" (click)="deletarModulo(item)"
                    title="Excluir módulo">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </app-card>
  </div>
  <div class="col-12 col-lg-4 col-xl-3 mb-3" *ngIf="moduloSelecionado">
    <!--<div class="col-3">-->
    <app-card cardTitle="Trilha" blockClass="table-border-style" [options]="false">
      <div class="row">
        <button type="button" class="btn btn-primary" data-toggle="modal" (click)="openModal(modalAddEtapa)">
          <i class="feather icon-plus-circle"></i>
          Cadastrar Nova Trilha</button>

      </div>
      <br>
      <div class="row">
        <div class="col-12">
          <div class="list-group list-group-flush">
            <div class="list-group-item py-2" *ngFor="let item of arrayEtapa"
              [ngClass]="{highlighted: selectedRowIndexEtapa == item.id}">
              <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
                <div class="d-flex align-items-center flex-grow-1 mr-lg-3" style="cursor: pointer;" (click)="selectEtapa(item)">
                  <div class="mr-2">
                    <div class="feed-user-img">
                      <img src="{{BASE_API + '/' + item.patH_AVATAR}}" class="img-radius" width="40" height="40">
                    </div>
                  </div>
                  <div>
                    <div class="font-weight-semibold text-break">
                      <i class="fas fa-circle f-10 m-r-5 text-warning" *ngIf="item.eH_RECUPERACAO"></i>{{item.titulo }}
                    </div>
                    <div class="small text-muted" *ngIf="!item.eH_RECUPERACAO">Ordem: {{item.ordem }}</div>
                    <div class="small mt-1">
                      <span *ngIf="item.obrigatorio && !item.eH_RECUPERACAO" class="badge badge-success">Obrigatório</span>
                      <span *ngIf="!item.obrigatorio && !item.eH_RECUPERACAO" class="badge badge-warning">Não obrigatório</span>
                      <span *ngIf="item.eH_RECUPERACAO" class="badge badge-warning">Recuperação</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-wrap align-items-center mt-2 mt-lg-0" style="gap: 0.4rem;">
                  <button type="button" class="btn btn-dark btn-sm" (click)="openModal(modalAddEtapa, item)"
                    title="Editar trilha">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button type="button" class="btn btn-danger btn-sm" (click)="deletarEtapa(item)"
                    title="Excluir trilha">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </app-card>
  </div>
  <div class="col-12 col-xl-6" *ngIf="etapaSelecionado">
    <!--<div class="col-6">-->

    <app-card cardTitle="Atividades" blockClass="table-border-style" [options]="false">
      <button type="button" class="btn btn-primary" data-toggle="modal" (click)="setHabilitaFormCadAtividade()">
        <i class="feather icon-plus-circle"></i>
        Cadastrar Nova Atividade
      </button>

      <div *ngIf="habilitarFormAtividade">
        <div class="row">
          <div class="col-md-6">
            <label class="sub-title">Nome Atividade</label>
            <input type="text" class="form-control" [(ngModel)]="nomeAtividade" name="nomeAtividade" placeholder="">
          </div>
          <div class="col-md-4">
            <label class="sub-title">Ordem</label>
            <input type="number" class="form-control" [(ngModel)]="ordemAtividade" name="ordemAtividade" placeholder="">
          </div>

        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="switch switch-success d-inline m-r-10">
                <input type="checkbox" id="obrigatorioAtividade" name="obrigatorioAtividade" [(ngModel)]="obrigatorioAtividade">
                <label for="obrigatorioAtividade" class="cr"></label>
              </div>
              <label>OBRIGATÓRIO</label>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <div class="switch switch-success d-inline m-r-10">
                <input type="checkbox" id="ehEscala"  [(ngModel)]="ehEscala">
                <label for="ehEscala" class="cr"></label>
              </div>
              <label>É ESCALA</label>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <div class="switch switch-success d-inline m-r-10">
                <input type="checkbox" id="necessitaResposta"  [(ngModel)]="necessitaResposta">
                <label for="necessitaResposta" class="cr"></label>
              </div>
              <label>PRECISA RESPOSTA?</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="sub-title">Descricão</label>
            <app-tinymce [(ngModel)]="descricaoAtividade" name="descricaoAtividade" #tinymce='tinymce'></app-tinymce>
            <!--<div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="descricaoAtividade"  [disabled]="false" [placeholder]="'Entre com a descrição da atividade'"></ngx-editor>
            </div>-->
            <!--<app-tinymce [(ngModel)]="descricaoAtividade" name="descricaoAtividade" #tinymce='tinymce'></app-tinymce>-->
            <!--<textarea rows="3" class="form-control" [(ngModel)]="descricaoAtividade" name="descricao"></textarea>-->
          </div>

          <div class="col-md-12">
            <br><br>
            <label class="sub-title">Ajuda</label>
            <app-tinymce [(ngModel)]="ajuda" name="ajuda" #tinymce='tinymce'></app-tinymce>
            <!--<textarea rows="3" class="form-control" [(ngModel)]="descricaoAtividade" name="descricao"></textarea>-->
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-4 text-right">
            <button type="button" class="btn btn-dark" (click)="openModal(modalAddMidia)">
              <i class="feather icon-plus-circle"></i>
              Adicionar Midia
            </button>
          </div>
          <div class="col-md-4 text-center">
            <!--<button type="button" class="btn btn-warning" (click)="openModal(modalMensagens)">
              <i class="feather icon-plus-circle"></i>
              Mensagens
            </button>-->
          </div>
          <div class="col-md-4 text-left">
            <button type="button" class="btn btn-info" (click)="openModal(modalAddFormulario)">
              <i class="feather icon-plus-circle"></i>
              Add. Formulário
            </button>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-12" *ngIf="arrayMidiaSelecionadas.length > 0">
            <app-card [hidHeader]="true">

              <div class="table-responsive">
                <table class="table table-sm text-break">
                  <thead>
                    <tr>
                      <th class="small text-uppercase text-muted">Título</th>
                      <th class="small text-uppercase text-muted">Tipo</th>
                      <th class="small text-uppercase text-muted">Formato</th>
                      <th class="small text-uppercase text-muted text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of arrayMidiaSelecionadas">
                      <td class="small" style="white-space: normal; word-break: normal; overflow-wrap: anywhere; min-width: 160px;">{{item.titulo }}</td>
                      <td class="small" style="white-space: normal; word-break: normal; overflow-wrap: anywhere; min-width: 120px;">{{item.tipO_MIDIA_DESCRICAO }}</td>
                      <td class="small" style="white-space: normal; word-break: break-word;">{{item.contenT_TYPE }}</td>
                      <td class="small text-center" style="min-width: 64px;">
                        <button type="button" class="btn btn-danger btn-sm" ngbTooltip="Deletar"
                          (click)="removerMidia(item)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </app-card>
          </div>

        </div>
        <div class="row">
          <div class="col-12">
            <app-card [hidHeader]="true" cardClass="comp-card" *ngIf="formularioSelecionada">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-b-10">Formulário</h6>
                  <h5 class="text-c-yellow mb-0">{{formularioSelecionada?.titulo}}</h5>
                </div>
                <div class="col-auto">
                  <button type="button" class="btn btn-link text-danger p-0" (click)="removerFormulario()"
                    title="Remover formulário">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </app-card>
          </div>

        </div>
        <div class="row">
          <div class="col-12" >
            <app-alert *ngIf="objMensagens?.BoasVindas != ''" type="primary">Boas Vindas: {{objMensagens?.BoasVindas}}</app-alert>
            <app-alert *ngIf="objMensagens?.Sucesso != ''" type="success">Sucesso: {{objMensagens?.Sucesso}}</app-alert>
            <app-alert *ngIf="objMensagens?.Falha != ''" type="danger">Falha: {{objMensagens?.Falha}}</app-alert>
            <app-alert *ngIf="objMensagens?.Saida != ''" type="secondary">Saida: {{objMensagens?.Saida}}</app-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 text-left">
            <br>
            <button type="button" class="btn btn-danger" (click)="backHabilitaFormCadAtividade()">
              <i class="fa fa-chevron-circle-left"></i>
              Voltar
            </button>
          </div>
          <div class="col-md-6 text-right">
            <br>
            <button type="button" class="btn btn-primary" (click)="salvarAtividade()">
              <i class="feather icon-check-circle"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>

    </app-card>


    <app-card cardTitle="Atividades Salvas" blockClass="table-border-style" [options]="false">
      <div class="row">
        <div class="col-12">
          <perfect-scrollbar [style.max-height]="'584px'">
            <div class="list-group list-group-flush">
              <div class="list-group-item py-2" *ngFor="let item of arrayAtividades"
                [ngClass]="{highlighted: selectedRowIndexAtividade == item.id}">
                <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
                  <div class="mb-2 mb-xl-0">
                    <button type="button" class="btn btn-danger btn-sm" (click)="deletarAtividade(item)"
                      title="Excluir atividade">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="flex-grow-1 px-xl-3" style="cursor: pointer;" (click)="selectAtividade(item)">
                    <div class="d-flex flex-wrap align-items-center mb-1" style="gap: 0.4rem;">
                      <span class="badge badge-light-secondary">Ordem {{item.ordem}}</span>
                      <span class="font-weight-semibold text-break">{{item.titulo}}</span>
                    </div>
                    <div class="small text-muted" *ngIf="item?.formulario">
                      <i class="far fa-file-word text-c-green f-10 m-r-5"></i>
                      Form: {{item?.formulario?.titulo}}
                    </div>
                    <div class="small mt-2" *ngIf="item?.midias?.length">
                      Mídias:
                      <span *ngFor="let it of item?.midias" class="d-inline-block mr-2 mt-1">
                        <span class="badge badge-light-primary badge-pill f-12">{{it?.titulo || it?.nome}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
    </app-card>
  </div>
</div>
